(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pd-collection-editorial"] && !Shopify.designMode) return;
  try {
    
  const activatePdCollectionTab = (tab, shouldFocus = false) => {
    const compare = tab.closest('[data-pd-ce-mobile-compare]');

    if (!compare) {
      return;
    }

    const selectedIndex = tab.dataset.pdCeTab;

    compare.querySelectorAll('[data-pd-ce-tab]').forEach((candidate) => {
      const isSelected = candidate.dataset.pdCeTab === selectedIndex;
      candidate.classList.toggle('is-active', isSelected);
      candidate.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      candidate.tabIndex = isSelected ? 0 : -1;
    });

    compare.querySelectorAll('[data-pd-ce-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.pdCePanel !== selectedIndex;
    });

    if (shouldFocus) {
      tab.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-pd-ce-tab]');

    if (tab) {
      activatePdCollectionTab(tab);
    }
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest('[data-pd-ce-tab]');

    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      return;
    }

    const compare = tab.closest('[data-pd-ce-mobile-compare]');
    const tabs = Array.from(compare.querySelectorAll('[data-pd-ce-tab]'));
    const currentIndex = tabs.indexOf(tab);
    let nextIndex = currentIndex;

    if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    } else if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = tabs.length - 1;
    }

    event.preventDefault();
    activatePdCollectionTab(tabs[nextIndex], true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-ips-gift-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ips-gift-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    const error = form.querySelector('[role="alert"]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add these items. Please try again.');
      window.location.assign(form.elements.return_to.value);
    } catch (failure) {
      error.textContent = failure.message || 'Unable to add these items. Please try again.';
      error.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
